// Inline-note resolution for lessons.
// All notes are now LOCAL — Drive integration was removed.
//   • music-theory + ear-training: inline <NoteImage> blocks placed within
//     each lesson's prose body. No gallery (notesFor returns []).
//   • other courses: still use BOOK_PAGES gallery (locally hosted PNGs
//     under /public/notes-book/) until they get the inline treatment too.

import { BOOK_PAGES } from "@/data/book-pages";

export interface NoteFile {
  /** Local public/ URL — for pages extracted from the EFL book PDFs. */
  src: string;
  name?: string;
  /** "book" — page from the EFL book. (Drive "lesson" notes were retired.) */
  kind?: "book";
}

/** Courses where notes are placed *inline* via <NoteImage> in the lesson body.
 *  These return an empty array so the top-of-page gallery doesn't render
 *  duplicates of what's already inline. */
const INLINE_NOTE_COURSES = new Set(["music-theory", "ear-training", "the-beatles"]);

export function notesFor(courseSlug: string, order: string | number): NoteFile[] {
  if (INLINE_NOTE_COURSES.has(courseSlug)) return [];
  const key = `${courseSlug}/${order}`;
  return (BOOK_PAGES[key] ?? []).map((src, i) => ({
    src,
    name: `Page ${i + 1}`,
    kind: "book" as const,
  }));
}
